// extracted by mini-css-extract-plugin
module.exports = {"menu":"MembersMenu_menu__3-jzV","menu__attributes":"MembersMenu_menu__attributes__3i7RA","members__avatar":"MembersMenu_members__avatar__2XCXU"};